<template>
  <div class="policy" id="policy" :style="showPrivasi ? 'height:auto;' : ''">
    <p class="seemore" @click="showPrivasi = true" v-if="!showPrivasi"></p>
    <h2 class="title">Privacy Policy<span></span></h2>
    <div class="msgs">
      <div class="msg">
        <p>
          The developer of PT. LAYANAN ASIA BERSATU is HC Company India. PT. LAYANAN ASIA BERSATU ("we")
          recognizes the importance of protecting your personal, financial and
          transactional information ("information"). We guarantee that
          information provided to us will be kept strictly confidential and we
          will only use such information to better service your account, provide
          products and services you may have requested, and to inform you of
          other products and services that may be available to you. you are
          interested. We will not sell your personal information to any third
          parties. We will use our best endeavors to prevent the inadvertent
          disclosure of your information and personal details to unauthorized
          persons or any other third parties. We shall protect such information
          and personal details using the same degree of care that we use with
          our own confidential information.
        </p>
      </div>
      <div class="msg">
        <h4>
          Main information we collect:
        </h4>
        <p style="font-weight: 600">1. Personal information:</p>
        <p>
          including name, identity, address, phone number and other information
          to ensure the authenticity of the information provided by the user.
        </p>
        <p style="font-weight: 600;">2. Financial information:</p>
        <p>
          It is necessary to know the user's payment information, transaction
          records and other financial information in order to evaluate loans and
          issue loans.
        </p>
        <p style="font-weight: 600;">
          3. Contact list information:
        </p>
        <p>
          When a user applies for a loan, PT. LAYANAN ASIA BERSATU requires access to the
          user's contact list information (including: contact name, contact
          details, relationship) to verify the identity of the borrower, to
          secure the transaction and for fraud prevention analysis. The
          information collected will be encrypted and uploaded to
          https://kd.kaydences.com/ and will not be disclosed without
          permission.
        </p>
        <p style="font-weight: 600">4. SMS information:</p>
        <p>
          When a user applies for a loan, PT. LAYANAN ASIA BERSATU needs to obtain the user's
          SMS information (including: SMS content, SMS title, whether it is read
          or not), which is used to assess the user's credit rating and ensure
          the safety of the user's money. We protect the security of our users'
          information and the information collected will be encrypted and
          uploaded to https://kd.kaydences.com.
        </p>
        <p style="font-weight: 600">5. List of installed applications:</p>
        <p>
          We will obtain installed application information to prevent fraudulent
          defrauding customers, and evaluate your credit score.
        </p>
        <p style="font-weight: 600">6. File directory information:</p>
        <p>
          including audio, pictures, videos, downloaded files, etc. Assist the
          platform in conducting relevant risk assessments.
        </p>
        <p style="font-weight: 600">7. Device information:</p>
        <p>
          You need to collect information such as SSAID, MAC address, IMEI,
          hardware model, and operating system version. It is used to ensure the
          safety and legality of users using this product.
        </p>
        <p style="font-weight: 600">8. Camera information:</p>
        <p>
          For your smooth loan, we use cameras for detection, and we will
          strictly protect your data.
        </p>
        <p style="font-weight: 600">9. Location information:</p>
        <p>
          It is limited to obtain location information when the user uses the
          application to determine whether you are within our service range.
          When you close our application, we will no longer obtain your location
          information.
        </p>
        <p style="font-weight: 600">10. Storage space:</p>
        <p>
          Only financial SMS can be used for credit score evaluation and
          anti-fraud monitoring. The user's data will be encrypted and sent to
          https://kd.kaydences.com, using DES and AES encrypted storage, https
          encrypted transmission, and the storage time is only during the user's
          use of the application.
        </p>

        <p style="font-weight: 600">11. Social account information:</p>
        <p>
          This application needs to collect the user's social account
          information in order to better keep in touch with the user. The
          collected information will be encrypted and uploaded to
          https://kd.kaydences.com.
        </p>
      </div>
      <div class="msg">
        <h4>
          How we use the information collected:
        </h4>
        <p>
          Since the storage of your information is subject to national
          regulations and also to provide and improve service quality, we will
          use your personal information to improve its services to you and let
          you know about its new products or information that may be of interest
          to you , including having our representatives contact you. Information
          collected from you will be used in strict compliance with appropriate
          laws and regulations. We will ensure the security of your personal
          information and will not share, rent or sell your personal information
          with other third parties for any purpose.
        </p>
      </div>
      <div class="msg">
        <h4>Purpose of collecting personal information:</h4>
        <p>
          1. Determine that you are an eligible borrower <br />
          2. Manage credit accounts and other facilities and determine
          appropriate credit limits<br />
          3. Preventing fraud and money laundering, checking and evaluating
          applications for credit, credit-related or other facilities<br />
          4. Manage user accounts, verify and execute financial transactions
          related to the service<br />
          5. For the development of our mobile applications in order to always
          meet the future needs of our customers
        </p>
      </div>
      <div class="msg">
        <h4>
          How we store and protect your personal information:
        </h4>
        <p>
          Most of the information we hold about you will be stored
          electronically in secure data centers (https://kd.kaydences.com). We
          recognize the importance of protecting and managing the information
          you share with us. We use a range of physical and electronic security
          measures to protect the personal information we hold. In addition, we
          use computer protection measures such as firewalls, data encryption
          and physical access controls for our offices and files. We only grant
          access to those employees who need it to perform their job duties. Our
          security systems meet or exceed industry standards, and we constantly
          monitor the latest developments to ensure our systems evolve as
          required.
        </p>
      </div>
      <div class="msg">
        <h4>Your rights:</h4>
        <p>
          You have the following rights in relation to your personal data under
          applicable data protection legislation: <br />
          1.Right of access – information about any personal data that you have
          the right to process about you and the right to access such data, if
          any.<br />
          2.Right to rectification – You have the right to have inaccurate
          personal data about yourself rectified.<br />
          3.Right to erasure (“right to be forgotten”) – you have the right to
          have data about you erased if it is no longer necessary for the
          purposes for which it was collected. If you want to delete your
          personal information, you can contact us through the email
          (rger3454ty@gmail.com) and we will delete it after careful review.
        </p>
      </div>
      <div class="msg">
        <h4>Changes to this Policy:</h4>
        <p>
          We are constantly innovating and finding new ways to improve our
          services. Accordingly, we reserve the right to update or amend this
          Privacy Policy at any time, with or without notice, to reflect such
          improvements or any other changes in our business, or to comply with
          applicable data protection legislation.
          <br />
          Our privacy policy is always available on our website (under legal
          information) and on our apps (under support) so that users are always
          informed about what personal data we collect, how and for what purpose
          we process it and under what circumstances Such information may be
          shared under . You are advised to review the Privacy Policy
          periodically to be aware of any modifications. If you do not agree to
          the terms of this Policy, you should not use our Services.
        </p>
      </div>
      <div class="msg">
        <h4>Contact us:</h4>
        <p>
          If you have any questions or suggestions about this Privacy Policy,
          please feel free to contact us at the following email address:
          rger3454ty@gmail.com.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: "",
  },
  data() {
    return {
      showPrivasi: false,
    };
  },
  created() {
    console.log(this.showPrivasi);
    if (this.show == true) {
      this.showPrivasi = true;
    }
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
